import * as Constants from "../utils/Constants";
import ClientEventEndpoints from "../lib/ClientEvent/ClientEventEndpoints";

/*
 * A Collection of shared functionality that is needed in multiple of the
 * "Applications".
 */

class SharedFunctions {
  getUpdatedBoxItems = (newItems, originalItems) => {
    const toAdd = [];
    const toDelete = [];
    const notShippedItems = originalItems.filter((obi) => obi.shippingID === -1);
    newItems.forEach((nbi) => {
      const match = notShippedItems.find(
        (obi) => nbi.skuID === obi.skuID && nbi.shelfNumber === obi.shelfNumber
      );
      if (match) {
        if (nbi.delete) {
          toDelete.push(match);
        } else {
          toDelete.push(match);
          nbi.verifiedQuantity = match.verifiedQuantity;
          nbi.partialQuantity = match.partialQuantity;
          toAdd.push(nbi);
        }
      } else {
        toAdd.push(nbi);
      }
    });
    let newList = originalItems.filter(
      (obi) =>
        obi.shippingID !== -1 ||
        !toDelete.filter((nbi) => nbi.skuID === obi.skuID && nbi.shelfNumber === obi.shelfNumber)
          .length
    );
    newList = newList.concat(toAdd);
    return newList;
  };

  mergeItems = (keyToCompare, itemsToMerge) => {
    return itemsToMerge && itemsToMerge.length
      ? itemsToMerge
          .map((x) => [{ ...x }])
          .reduce((a, b) => {
            if (a) {
              const fB = b[0];
              const match = a.find((x) => x[keyToCompare] === fB[keyToCompare]);
              if (match) {
                if ("reservedQuantity" in fB) {
                  match.reservedQuantity += fB.reservedQuantity;
                }
                if ("verifiedQuantity" in fB) {
                  match.verifiedQuantity += fB.verifiedQuantity;
                }
                if ("partialQuantity" in fB) {
                  match.partialQuantity += fB.partialQuantity;
                }
                if ("shelfNumber" in fB) {
                  match.shelfNumbers = (match.shelfNumbers || []).concat(fB.shelfNumber);
                }
                if ("pickedByName" in fB) {
                  match.pickedByName = (match.pickedByName || "") + ", " + (fB.pickedByName || "");
                }
                if ("missingQuantity" in fB){
                  match.missingQuantity += fB.missingQuantity
                }
                return a;
              }
            }
            return a.concat(b);
          })
      : [];
  };

  async LogPopupShownEvent(param) {
    if (typeof param === 'string' || param instanceof String) {
    await ClientEventEndpoints.logClientEvent(Constants.ClientEvents.ModalPoppedUp, {
      modalComponentName: param,
    });
    }else if (Object.keys(param).length > 1){ // full event loggning
      await ClientEventEndpoints.logClientEvent(Constants.ClientEvents.ModalPoppedUpExtendedInfo,  param);
    }
  }

  async LogScannedRXBag(EAN) {
    await ClientEventEndpoints.logClientEvent(Constants.ClientEvents.ScanRXBag, {
      scannedEAN: EAN,
    });
  }

  async LogIncorrectScannedRXBag(EAN, orderNumber) {
    await ClientEventEndpoints.logClientEvent(Constants.ClientEvents.IncorrectRXBagScan, {
      scannedEAN: EAN, orderNumber
    });
  }

  async LogBetaVersionRedirect(isBeta, app, workstationID) {
    await ClientEventEndpoints.logClientEvent(Constants.ClientEvents.BetaVersionRedirect, {
      betaVersion: isBeta,
      appName: app,
      workstationID: workstationID,
    });
  }
}

export default new SharedFunctions();
